import React from 'react';
import PropTypes from 'prop-types';
import TextNodeContainer from './text-node';
import ImageNode from './image-node';
import AudioNodeContainer from './audio-node';
import VideoNode from './video-node';
import SlideshowNode from './slideshow-node';
import classnames from 'classnames';
import {withRouter} from 'react-router-dom';
import {isEmpty} from '../../../../utilities/validation';


const getDataFromNode = function(node) {
    return ['id', 'title', 'x', 'y', 'src', 'alpha', 'width', 'height', 'non_sprite_image', 'zIndexOverride'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

const determineChildZIndex = (behavior, zIndex) =>{
    // need a function which uses the ce-node behaviour attribute to determine what z-index of ce-button-node
    // children should be; Check MOD-1886 PARENT ISSUE, and relevant children issues
    // for example when behaviour === "click" as per comment in ceDownButtonEvent the pop-up/overlay auto
    // closes wherever we click if it is visible, therefore it is safe to assume that all node children in this
    // case should have a higher z-index than the ce-button-node itself, so that the ce-button-node(s) do not
    // appear atop the children
    // on the other hand when behaviour === "normal" as in Weather 3.5.1 page 219 it is usually an
    // interactive slide where the students can compare the difference between different choices and the
    // "popups"/"overlays" appear as to be interacting with the original background image of the slide
    if(['click', 'erase'].indexOf(behavior) >= 0){
        return (zIndex + 2);
    }else if (behavior === 'normal'){
        return (zIndex - 1);
    }else{
        return  zIndex;
    }
};

class CeButtonNode extends React.Component {
    constructor(props) {
        super(props);

        const graphicState = props.selected ? 'selected' : '';

        this.audioEnded = this.audioEnded.bind(this);
        this.videoEnded = this.videoEnded.bind(this);
        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            required: props.required,
            enabled: props.enabled,
            isCeButtonVisible: props.isCeButtonVisible,
            zIndex: props.zIndex,
            graphicState,
        };

        this.disableTip = this.disableTip.bind(this);
        this.ceButtonRef = null;
        this.ceButtonMouseDown = this.ceButtonMouseDown.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            isTipOpen: nextProps.isTipVisible,
            isCeButtonVisible: nextProps.isCeButtonVisible
        });
        if (this.props.selected !== nextProps.selected) {
            this.setState({
                graphicState: nextProps.selected ? 'selected' : ''
            });
        }
        // React will not trigger a re-play of the audio when the component is re-rendered so we have to invoke play manually.
        if (this.audioRef) {
            this.audioRef.audio.play();
        }
        if (this.videoRef) {
            this.videoRef.video.play();
        }
    }

    componentDidMount() {
        document.addEventListener('jre-audio-ended', this.audioEnded);
        document.addEventListener('jre-video-ended', this.videoEnded);
        document.addEventListener('mousedown', this.ceButtonMouseDown);
    }

    componentWillUnmount() {
        document.removeEventListener('jre-audio-ended', this.audioEnded);
        document.removeEventListener('jre-video-ended', this.videoEnded);
        document.removeEventListener('mousedown', this.ceButtonMouseDown);
    }

    disableTip() {        
        if(this.state.isTipOpen && this.props.isTipVisible){
            this.setState({
                isTipOpen: false
            });
            this.props.disableTip();

            //it is for prevent to page disabled
            const el = document.querySelectorAll(".jre-tip");
            // console.log(el);       
            if(el != null){          
            el.forEach(function(element) {
            element.classList.remove("overlay-mask");
            });            
            } 
            //it is for prevent to page disabled
        }
    }

    onImgLoad({target: img}) {
        const {non_sprite_image} = this.state;

        if (non_sprite_image) {
            // source image contains a single element
            this.setState({height: parseInt(img.offsetHeight)});
        } else {
            // source image is a sprite image (a single image containing 5 elements).
            this.setState({height: parseInt(img.offsetHeight) / 5});
        }
    }

    styleBackgroundPosition() {
        const {graphicState, non_sprite_image, height,} = this.state;

        //if no other sprites exist (non_sprite_image), then we don't shift the image
        if (non_sprite_image){
            return '0 0';
        }

        // On April 8th according to PITSCO, ALL sprite images, for ALL node types have the following index
        // properties: 1 -base, 2 - base, 3 - active, 4 - hover, 5 - disabled => array equivalent [0,1,2,3,4]
        // IF the sprite images appear in an incorrect order, forward ticket back to Pitsco and notify them that
        // sprite image order is incorrect, and send them index order which would replicate FRE functionality
        // DO NOT use Transformers!
        if (graphicState === 'selected') {
            // graphicState selected corresponds to 3 - Active state
            return `0 -${parseInt(height) * 2}px`;
        } else if (graphicState === 'hover') {
            // graphicState hover corresponds to 4 - hover (mouseOver) state
            return `0 -${parseInt(height) * 3}px`;
        } else if (graphicState === 'disabled') {
            // graphicState disabled corresponds to 5 - Disabled state
            return `0 -${parseInt(height) * 4}px`;
        } else {
            // Selected is null; ->
            // BASE state corresponds to 1 - base and 2 - base
            return '0 0';
        }
    }

    getListItems(node) {
        const {moduleURL = '', behavior, enableJREAppPlayerContainerButtons, disableJREAppPlayerContainerButtons,
            zIndex,} = this.props;

        const childZIndex = determineChildZIndex(behavior, zIndex);

        return node.children.map(n => {
            switch (n.name) {
                case 'text_node':
                    // Text needs to be above image node.
                    return <TextNodeContainer key={n.attr.id} node={n} zIndex={childZIndex}/>;
                case 'image_node':
                    return <ImageNode moduleURL={moduleURL} key={n.attr.id} node={n} zIndex={childZIndex}/>;
                case 'slideshow_node':
                    return <SlideshowNode parentNodeType="ce-button" moduleURL={moduleURL} key={n.attr.id} node={n}
                                          enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                                          disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                case 'audio_node':
                    return <AudioNodeContainer parentNodeType="ce-button" moduleURL={moduleURL}
                                               ref={(audio) => { this.audioRef=audio; }} key={n.attr.id} node={n}
                                               enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                                               disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                case 'video_node':
                    // Video needs to be above image node.
                    // Video also needs to be above ce-button-nodes MOD-1354 (Rocketry & Space - 3.0.1, p307; however
                    // issue is that behavior is normal and we can't use the default childZIndex, therefore if
                    // props.zIndex = 3 and behavior normal, then childZIndex = 2, we add 2 to make video_node zIndex 4
                    // Decided to add 2 here because of .map function preventing us from passing node.children.n.name
                    // and IIFE can render bubbling
                    return <VideoNode moduleURL={moduleURL}  zIndex={childZIndex + 2}
                                      ref={(video) => { this.videoRef=video; }} key={n.attr.id} node={n}
                                      enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                                      disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                default:
                    return null;
            }
        });
    }

    onButtonMouseOver() {
        // this.setState({ hovered:true });
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: 'hover'
            });
        }
    }

    onButtonMouseOut() {
        // this.setState({ hovered:false });
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: ''
            });
        }
        const el2 = document.querySelectorAll(".jre-tip");
        // console.log(el2);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         

        if(el2 != null){          
            el2.forEach(function(element) {
        element.classList.remove("overlay-mask");
        });            
        } 
    }

    audioEnded() {                   
        
        const el = document.querySelectorAll(".jre-tip");
        // console.log(el);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         

        if(el != null){          
        el.forEach(function(element) {
        element.classList.remove("overlay-mask");
        });            
        } 
       
        this.setState({hovered: false});
    }

    videoEnded() {
        this.setState({hovered: false});
        const el2 = document.querySelectorAll(".jre-tip");
        // console.log(el2);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         

        if(el2 != null){          
            el2.forEach(function(element) {
        element.classList.remove("overlay-mask");
        });            
        } 
    }

    ceButtonMouseDown(event) {
        /**
         * For Ce buttons, behavior can be "normal" or "click". When behavior is "click", click events outside
         * the button will close the content initially opened by the click event. When the behavior is "normal" then
         * clicking outside the button will NOT close the content but rather it will remain visible.
         * Edit: July 24th 2019, PITSCO notified Barney to also treat erase behavior as click
         */
        const {behavior} = this.props;
        if (!(['click', 'erase'].indexOf(behavior) >= 0)) {
            return;
        }
        // Prevent the ce_button_node from closing all children when a specified node is clicked.
        if (isEmpty(event.target.className.split(' ').filter(value =>
            ['ce_button', 'video-node', 'jre-text-node', 'slideshow-button-node'].includes(value)))){
            this.props.clearCeNodeContentView();
        }
    }

    render() {
        const {moduleURL = '', isTipVisible=false, title=''} = this.props;
        let {x, y, src, height = 0, width = 0, selected = null, required = false, isCeButtonVisible = true,
            zIndex = null, isTipOpen=false, alpha = undefined, zIndexOverride} = this.state;
        // Fallback if there is no height set for the image. There should not be any images with a height less than 10px
        if(parseFloat(height) < 10.00) {
            height = '100%';
        } else {
            height = `${height}px`;
        }
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            height: height,
            backgroundPosition: this.styleBackgroundPosition(),
        };
        if (width) {
            divStyle.width = `${width}px`;
        }
        if (src) {
            divStyle.background = `url(${moduleURL}/media/${src}) no-repeat`;
        }

        if (alpha) {
            /* Note that alpha is coming in as a string so when the statement if (alpha) compares against "0", it will
            enter this block. */
            divStyle.opacity = alpha;
        } else if (selected !== null && required === true) {
            // I'm not sure if this 0.8 opacity is required since we set it above but its being preserved here.
            divStyle.opacity = 0.8;
        }

        const CeClass = classnames('ce-button', {
            node: true,
            active: selected,
        });

        if (zIndex !== null && isCeButtonVisible) {
            //Sometimes another image will appear over a ce-button-node's image. The z-index here shouldn't be higher than the new image.
            divStyle.zIndex = parseInt(zIndex) + 1;
        }

        // MOD-2129 has a specific button that was required to be rendered below the ce-button-node popup, to
        // accomplish this I decided to replicate zIndexOverride functionality from text0bide.
        if (zIndexOverride) {
            divStyle.zIndex = zIndexOverride;
        }

        return (
            <div>
                {isCeButtonVisible &&
                <button
                    ref={ceButton => this.ceButtonRef = ceButton}
                    className={CeClass} style={divStyle} onMouseOut={this.onButtonMouseOut.bind(this)}
                    onMouseOver={this.onButtonMouseOver.bind(this)} onClick={this.props.onClick}>
                    {src &&
                    <img onLoad={this.onImgLoad.bind(this)} src={`${moduleURL}/media/${src}`} className="visibility-hidden"/>}
                </button>}


                {((isTipVisible && isTipOpen) || (title.toLowerCase() !== 'tip')) &&
                <div>
                    { (title.toLowerCase() === 'tip') &&
                    <div
                        className="overlay-mask overlay-mask2" 
                        onClick={this.disableTip}
                    />
                    }
                    <div className="jre-tip overlay-mask">
                        {
                            this.props.childrenVisible ? this.getListItems(this.props.node) : null
                        }
                    </div>
                </div>
                }
            </div>
        );
    }
}

CeButtonNode.propTypes = {
    node: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    childrenVisible: PropTypes.bool,
    height: PropTypes.number,
    selected: PropTypes.bool,
    required: PropTypes.bool,
    enabled: PropTypes.bool,
    index: PropTypes.number
};

export default withRouter(CeButtonNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/ce-button-node.js